export default __webpack_public_path__ + "static/media/image-main-1-m@3x.532ac4a5.webp";